import { makeStyles } from '@material-ui/core'
import { pink } from '@material-ui/core/colors'

const styles = makeStyles((theme) => ({
  chip: { color: theme.palette.white, textTransform: 'uppercase' },
  black: { backgroundColor: theme.palette.black },
  blue: { backgroundColor: theme.palette.azure },
  green: { backgroundColor: theme.palette.greenPantone },
  red: { backgroundColor: theme.palette.darkRed },
  pink: { backgroundColor: pink[900] },
}))

export default styles
